module.exports = __webpack_public_path__ + "img/u39.7339759a.png";